{
  "$id": "module://employee-type",
  "$schema": "wealthlane://schemas/domain",
  "title": "Employee Type",
  "description": "Customer employee type field catalog",
  "type": "object",
  "properties": {
    "name": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 1000,
      "adapterProps": { "rows": 5 }
    },
    "isTaxEnable": {
      "type": "boolean",
      "title": "Withhold Tax",
      "widget": "checkbox"
    }
  }
}
